<app-learning-path-introduction *ngIf="isShowIntroduction&&learningPathMetaId!=404&&learningPathMetaId!=12&&learningPathMetaId!=18&&learningPathMetaId!=26&&learningPathMetaId!=30" [onceValue]="onceValue" [learningPathMetaId]="learningPathMetaId"  [assetsRoute]="assetsRoute" (onCloseLearningPathIntroduction)="closeLearningPathIntroduction()"></app-learning-path-introduction>
<app-com-tip *ngIf="isShowTip" (onCancel)="exitTip()" [type]="'tip'" [desText]="desText" [cancelText]="'知道了'" [sureText]="''" ></app-com-tip>
<app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>
<app-questionnaire [enter]="0" [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire" (onExit)="closeQuestionnaire()"></app-questionnaire>
<app-loading-component *ngIf="!canShow"></app-loading-component>
<div class="learning-path-wrap" *ngIf="learningPath&&mode&&status&&canShow">
  <div *ngIf="abilityBack" class="common-back-btn-sight" id="backBtn"  (click)="goToLearningProject()" style="top:.2rem">
    <i class="fa fa-angle-left icon"></i>
  </div>
  <div id="title" class="fontSize18 title">
    {{appRename.getShowName(learningPath.name)}}
  </div>

  <div class="learning-path-desc">
    <p>{{learningPath.description}}<span *ngIf="learningPathMetaId == 12 || learningPathMetaId==30 || learningPathMetaId == 18 || learningPathMetaId == 26 || learningPathMetaId == 404">。</span><span *ngIf="learningPathMetaId!=12 && learningPathMetaId!=30 && learningPathMetaId!=18 && learningPathMetaId!=26 && learningPathMetaId!=404" style="padding-right: .2rem">...</span><span *ngIf="learningPathMetaId!=12 && learningPathMetaId!=30 && learningPathMetaId!=18 && learningPathMetaId!=26 && learningPathMetaId!=404" (click)="showIntroduction()" style="text-decoration:underline">详细></span></p>
<!--    <p *ngIf="results.length!==0">学习收获：</p>-->
<!--    <div *ngFor="let item of results;let i=index">{{item}}</div>-->
  </div>


  <div class="learning-path-theme-pic">
    <img src="{{assetsRoute}}/picture/learningpath/{{learningPathMetaId}}.png" alt="" />
  </div>

  <div class="learning-path-card-wrap">
    <component-progress-bar [type]="'bar'" [theme]="progressBarTheme" [progress]="progress" [isShowBar]="isShowBar"></component-progress-bar>
    <div class="learning-path-card-item {{i}}" [ngClass]="{'disabled':(learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock}" *ngFor="let item of learningPath.subItems;let i=index" (click)="cardClick(i)">
      <div class="card-icon u-lof4">
        <img *ngIf="!((learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock)" src="{{assetsRoute}}/picture/learningpath/icon/{{item.type}}.png" alt="" />
        <img *ngIf="(learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock" src="{{assetsRoute}}/picture/learningpath/icon/{{item.type}}-disabled.png" alt="" />
      </div>
      <!-- 测学练考 -->
      <div class="card-content">
        <div class="card-title" [ngClass]="{'disableTxt':(learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock}">
          <span *ngIf="item.type==1">能力诊断</span>
          <span *ngIf="item.type==2">课程学习</span>
          <span *ngIf="item.type==3">情景模拟</span>
          <span *ngIf="item.type==4">能力考核</span>
        </div>
        <!-- 课程简介 -->
        <div class="card-desc" [ngClass]="{'disableTxt':(learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock}">{{item.desc}}</div>
        <!-- 课程学习时常 -->
        <div class="card-clock" [ngClass]="{'disableTxt':(learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock}">{{item.time}}</div>
        <div *ngIf="item.courseLockdata.lock">
          <!-- 小锁图标 -->
          <div class="card-lock" *ngIf="item.courseLockdata.lockType == 2 && ((learningPath.currentItemIndex<i+1 && !learningPath.subItems[i].openAt) || (learningPath.subItems[i].openAt && learningPath.subItems[i].isLock) || item.courseLockdata.lock)"></div>
          <!-- 根据日期锁定课程 -->
          <div *ngIf="item.courseLockdata.lockType == 1">
            <component-datestates-bar [isPC]="isPC" [openTime]="item.courseLockdata.openTime"></component-datestates-bar>
          </div>
        </div>
        
      </div>
    </div>
  </div>

</div>





// WEBPACK FOOTER //
// ./src/app/learning-project-path/learning-project-path.component.html